var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgWhatsapp = function SvgWhatsapp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.323 0a9.328 9.328 0 0 0-7.985 14.14l-1.16 4.476 4.64-1.128A9.326 9.326 0 1 0 9.322 0zm0 17.087a7.71 7.71 0 0 1-4.27-1.283l-2.735.694.709-2.623a7.758 7.758 0 1 1 6.296 3.21v.002z",
    fill: "#191919"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.075 11.18c-.126-.065-.262-.118-.369-.175l-.921-.502a.602.602 0 0 0-.299-.103c-.407 0-.596.61-.86.84a.657.657 0 0 1-.377.19.737.737 0 0 1-.334-.094 5.592 5.592 0 0 1-1.456-1.028 8.313 8.313 0 0 1-.904-1.083 1.246 1.246 0 0 1-.275-.582c-.058-.534.68-.722.7-1.253a1.32 1.32 0 0 0-.161-.56 7.973 7.973 0 0 1-.35-.945c-.174-.591-.509-.844-1.127-.701-.767.175-1.172 1.286-1.196 2.005-.039 1.06.672 2.113.769 2.256.443.717.95 1.388 1.516 2.006a7.075 7.075 0 0 0 3.662 2.005 2.5 2.5 0 0 0 .791.03 1.874 1.874 0 0 0 1.167-.664c.271-.326.623-.935.361-1.356a.812.812 0 0 0-.337-.286z",
    fill: "#191919"
  })));
};

export default SvgWhatsapp;